module.exports = __webpack_public_path__ + "static/media/wind-marker.10a12942.svg";